import { useState } from "react";
import { Box, Button, Stepper, Step, StepLabel, Paper } from "@mui/material";
import ModuleHeader from "../../../components/ModuleHeader";
import ReportTypeSelector from "./components/ReportTypeSelector";
import ReportFilters from "./components/ReportFilters";
import ReportPreview from "./components/ReportPreview";
import "./reports.css";

const STEPS = ["Select Report Type", "Configure Filters", "Preview & Download"];

export default function ReportsLanding() {
  const [activeStep, setActiveStep] = useState(0);
  const [selectedReport, setSelectedReport] = useState(null);
  const [filters, setFilters] = useState({
    clientId: "",
    dateRange: "last_month",
    startDate: "",
    endDate: "",
  });

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    setSelectedReport(null);
    setFilters({
      clientId: "",
      dateRange: "last_month",
      startDate: "",
      endDate: "",
    });
  };

  const canProceed = () => {
    if (activeStep === 0) return selectedReport !== null;
    if (activeStep === 1) return true;
    return false;
  };

  return (
    <Box sx={{ p: 3 }}>
      <ModuleHeader
        title="Reports"
        subtitle="Generate and download financial reports for your clients"
      />

      <Paper sx={{ p: 3, mt: 3, border: "1px solid var(--peb-stone)" }}>
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
          {STEPS.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box sx={{ minHeight: 300 }}>
          {activeStep === 0 && (
            <ReportTypeSelector
              selected={selectedReport}
              onSelect={setSelectedReport}
            />
          )}

          {activeStep === 1 && (
            <ReportFilters
              filters={filters}
              onChange={setFilters}
            />
          )}

          {activeStep === 2 && (
            <ReportPreview
              reportType={selectedReport}
              filters={filters}
            />
          )}
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4, pt: 2, borderTop: "1px solid var(--peb-stone)" }}>
          <Button
            variant="outlined"
            onClick={activeStep === 0 ? handleReset : handleBack}
            disabled={activeStep === 0}
          >
            Back
          </Button>

          <Box sx={{ display: "flex", gap: 2 }}>
            {activeStep === 2 && (
              <Button variant="outlined" onClick={handleReset}>
                Generate Another Report
              </Button>
            )}

            {activeStep < 2 && (
              <Button
                variant="contained"
                onClick={handleNext}
                disabled={!canProceed()}
              >
                {activeStep === 1 ? "Generate Report" : "Next"}
              </Button>
            )}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
